import type { SalesManager } from '../types/voip';

export const salesManagers: SalesManager[] = [
  { team: 'Rivera', manager: 'Chris Rivera', label: "Chris's Team", trend: 6.2 },
  { team: 'Thompson', manager: 'Dana Thompson', label: "Dana's Team", trend: -3.4 },
  { team: 'Walsh', manager: 'Kevin Walsh', label: "Kevin's Team", trend: 4.1 },
  { team: 'Nguyen', manager: 'Erin Nguyen', label: "Erin's Team", trend: 2.7 },
  { team: 'Park', manager: 'Sam Park', label: "Sam's Team", trend: -1.2 },
];
